<template>
  <div class="ps-grid-2 card-item origin-base-form ps-supply-form">
    <div class="title-box ps-grid-full">
      <span class="title-text">补充材料</span>
      <span class="btn-action-group"></span>
    </div>
      <div class="ps-field ps-grid-full">
        <label>
          <span class="req">*</span> 补充视频类型
          <a-tooltip
            placement="right"
            v-if="
              bqInfo?.nowContent &&
              bqInfo?.changeContent &&
              JSON.parse(bqInfo?.changeContent).type !=
                JSON.parse(bqInfo?.nowContent).type
            "
          >
            <template slot="title">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                思政微课视频:<span
                  style="color: #2155b5; cursor: pointer"
                  @click="yl(JSON.parse(bqInfo?.changeContent))"
                  >{{
                    JSON.parse(bqInfo?.changeContent).type == 0
                      ? "本地视频"
                      : "超链接"
                  }}</span
                >
                <span style="color: #3498db; font-size: 20px">→</span
                ><span
                  style="color: #2155b5; cursor: pointer"
                  @click="yl(JSON.parse(bqInfo?.nowContent))"
                  >{{
                    JSON.parse(bqInfo?.nowContent).type == 0
                      ? "本地视频"
                      : "超链接"
                  }}</span
                >
              </div>
            </template>
            <span class="ps-compare-link">数据对比</span>
          </a-tooltip>
        </label>
        <a-radio-group
          name="radioGroup"
          :disabled="isEdit"
          v-model="info.type"
          @change="handleTypeChange"
        >
          <a-radio value="0">本地视频</a-radio>
          <a-radio value="1">超链接</a-radio>
        </a-radio-group>
      </div>

      <template v-if="info.type == 0">
        <div class="ps-field ps-grid-full">
          <label>
            <span class="req">*</span> 思政微课视频
            <a-tooltip
              placement="right"
              v-if="
                bqInfo?.nowContent &&
                bqInfo?.changeContent &&
                JSON.parse(bqInfo?.changeContent).name !=
                  JSON.parse(bqInfo?.nowContent).name
              "
            >
              <template slot="title">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  思政微课视频:<span
                    style="color: #2155b5; cursor: pointer"
                    @click="yl(JSON.parse(bqInfo?.changeContent))"
                    >{{ JSON.parse(bqInfo?.changeContent).name }}</span
                  >
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span
                    style="color: #2155b5; cursor: pointer"
                    @click="yl(JSON.parse(bqInfo?.nowContent))"
                    >{{ JSON.parse(bqInfo?.nowContent).name }}</span
                  >
                </div>
              </template>
              <span class="ps-compare-link">数据对比</span>
            </a-tooltip>
          </label>
          <a-upload
            :file-list="fileList"
            accept=".mp4"
            :remove="(file, fileList) => handleRemove(file, fileList)"
            :disabled="isEdit || loading"
            :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            :style="{ cursor: isEdit ? 'pointer' : '' }"
            @preview="handlePreview"
          >
            <button
              type="button"
              class="ps-upload-btn"
              :disabled="isEdit || loading"
            >
              <a-icon type="upload" />
              {{ loading ? "上传中..." : "上传附件" }}
            </button>
            <span class="ps-file-note">请上传视频</span>
          </a-upload>
        </div>
      </template>

      <template v-else>
        <div class="ps-field">
          <label>
            <span class="req">*</span> 超链接名称
            <a-tooltip
              placement="right"
              v-if="
                bqInfo?.nowContent &&
                bqInfo?.changeContent &&
                JSON.parse(bqInfo?.changeContent).name !=
                  JSON.parse(bqInfo?.nowContent).name
              "
            >
              <template slot="title">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  超链接名称:<span
                    style="color: #2155b5; cursor: pointer"
                    @click="yl(JSON.parse(bqInfo?.changeContent))"
                    >{{ JSON.parse(bqInfo?.changeContent).name }}</span
                  >
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span
                    style="color: #2155b5; cursor: pointer"
                    @click="yl(JSON.parse(bqInfo?.nowContent))"
                    >{{ JSON.parse(bqInfo?.nowContent).name }}</span
                  >
                </div>
              </template>
              <span class="ps-compare-link">数据对比</span>
            </a-tooltip>
          </label>
          <a-input
            v-model="info.name"
            placeholder="请输入超链接名称"
            :disabled="isEdit"
          />
        </div>
        <div class="ps-field">
          <label>
            <span class="req">*</span> 思政微课超链接
            <a-tooltip
              placement="right"
              v-if="
                bqInfo?.nowContent &&
                bqInfo?.changeContent &&
                JSON.parse(bqInfo?.changeContent).filePath !=
                  JSON.parse(bqInfo?.nowContent).filePath
              "
            >
              <template slot="title">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  思政微课超链接:<span
                    style="color: #2155b5; cursor: pointer"
                    @click="yl(JSON.parse(bqInfo?.changeContent))"
                    >{{ JSON.parse(bqInfo?.changeContent).filePath }}</span
                  >
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span
                    style="color: #2155b5; cursor: pointer"
                    @click="yl(JSON.parse(bqInfo?.nowContent))"
                    >{{ JSON.parse(bqInfo?.nowContent).filePath }}</span
                  >
                </div>
              </template>
              <span class="ps-compare-link">数据对比</span>
            </a-tooltip>
          </label>
          <a-input
            v-model="info.filePath"
            placeholder="请输入超链接地址"
            :readOnly="isEdit"
            :style="
              isEdit && info.filePath
                ? { cursor: 'pointer', color: '#2155b5' }
                : {}
            "
            @click="openHyperlink"
          />
        </div>
      </template>

      <div class="ps-field ps-grid-full">
        <label>
          <span class="req">*</span> 思政元素
          <a-tooltip
            placement="right"
            v-if="
              bqInfo?.nowContent &&
              bqInfo?.changeContent &&
              JSON.parse(bqInfo?.changeContent).ideologicalElement !=
                JSON.parse(bqInfo?.nowContent).ideologicalElement
            "
          >
            <template slot="title">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                思政元素:<span>{{
                  JSON.parse(bqInfo?.changeContent).ideologicalElement
                }}</span>
                <span style="color: #3498db; font-size: 20px">→</span
                ><span>{{
                  JSON.parse(bqInfo?.nowContent).ideologicalElement
                }}</span>
              </div>
            </template>
            <span class="ps-compare-link">数据对比</span>
          </a-tooltip>
        </label>
        <a-select
          mode="tags"
          style="width: 100%"
          :disabled="isEdit"
          v-model="info.ideologicalElement"
          placeholder="请选择思政元素"
        >
          <a-select-option
            v-for="item in ysList"
            :key="item.name"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

    <div class="preview-pop-box" v-if="showvideo">
      <div class="preview-boxs" style="height: 600px">
        <videopreview
          :sj="sjData"
          @closePreview="showvideo = false"
        ></videopreview>
      </div>
    </div>
  </div>
</template>

<script>
import { fileUpdate } from "../../api/index";
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import { baseURL } from "@/utils/request.js";
import videopreview from "@/components/common/videopreview";
import mixin from "@/utils/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: { videopreview },
  //   props: {
  //     fileLists: {
  //       type: Array,
  //     },
  //     oldInfos:{
  //     	type: Object,
  //     },
  //     isEdit:{
  //       type:Boolean,
  //     }
  //   },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        console.log(newValue, "9999999999999999");
        if (newValue != null && newValue != undefined && newValue) {
          //   this.oldInfo=newValue;
          // console.log(this.oldInfos.type);
          if (
            this.$route.query.new == "preview" ||
            this.$parent?.news == "preview" ||
            (this.$parent.editInfo &&
              this.$parent.editInfo?.type == "preview") ||
            this.oldInfos?.type == "preview"
          ) {
            this.isEdit = true;
          } else {
            this.isEdit = false;
          }
          this.getbq();
          //   this.addTeacher();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
      immediate: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        console.log(newValue, "我是");
        if (
          this.$route.query.new == "preview" ||
          this.$parent?.news == "preview" ||
          this.$parent?.editInfo?.type == "preview" ||
          this.oldInfos?.type == "preview"
        ) {
          this.isEdit = true;
          return;
        }
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  data() {
    return {
      info: {
        ideologicalElement: [],
        type: "0",
      },
      ysList: [],
      //    applyFiles: [],
      path: baseURL,
      loading: false,
      type4: false,
      type5: false,
      type6: false,
      submitLoading: null,
      fileList: [],
      isEdit: false,
      showvideo: false,
      previewUrl: "",
      file: "",
      sourceType: "alioss",
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-beijing",
      userId: "1104845979036938",
      uploadDisabled: true,
      resumeDisabled: true,
      statusText: "",
      sjData: {},
      bqInfo: {},
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.getysList();
    //    let oldInfo = JSON.parse(
    //     sessionStorage.getItem(`step${this.$store.state.user.id}`)
    //   );
    //   if(oldInfo){
    //     this.oldInfo=oldInfo;
    //     // this.isEdit = oldInfo?.type == "preview";
    //   }
    //   console.log(this.oldInfo,"11111111");
    //	    if(this.oldInfo && this.oldInfo.ideologicalElement!=''){
    //    	let ideologicalElement=this.oldInfo.ideologicalElement;
    //    	if(ideologicalElement.indexOf(",")!='-1'){
    //    		 this.info.ideologicalElement=ideologicalElement.split(',');
    //    	}else{
    //    		 let arr=[];
    //    		 arr.push(ideologicalElement);
    //    		 this.info.ideologicalElement=arr;
    //    	}
    //    	if(this.oldInfo &&  Array.isArray(this.oldInfo.ideologicalElement) && this.oldInfo.ideologicalElement.length > 0){
    //    		this.info.ideologicalElement=this.oldInfo.ideologicalElement;
    //    	}
    //    }
    //   this.fileList=this.fileLists;
    //	  console.log(this.oldInfo,"11111111");
    //   if(this.oldInfo){
    //   	 this.getbq();
    //   }
  },
  methods: {
    openHyperlink() {
      if (!this.isEdit) return;
      const url = (this.info && this.info.filePath) || "";
      if (!url || url === "null") {
        this.$message.warning("暂无超链接地址");
        return;
      }
      const href = /^https?:\/\//i.test(url) ? url : `http://${url}`;
      window.open(href, "_blank");
    },
    handleTypeChange(e) {
      const newType = String(e.target.value);
      // 重置所有相关的数据字段
      if (newType === "0") {
        // 切换到本地视频，清空超链接相关字段
        this.info.filePath = "";
        this.info.name = "";
        this.info.aliId = "";
        this.info.fileName = "";
        this.info.sourceType = "alioss";
      } else if (newType === "1") {
        // 切换到超链接，清空本地视频相关字段
        this.info.aliId = "";
        this.info.fileName = "";
        this.info.sourceType = "";
        this.fileList = []; // 清空文件列表
        this.loading = false; // 重置加载状态
      }
      this.$set(this.info, "type", newType);
    },
    /** 统一补充材料类型为字符串，避免 radio 数字/字符串对不上切不过去 */
    normalizeResourceType(type) {
      if (type === 1 || type === "1") return "1";
      return "0";
    },
    yl(sj) {
      this.sjData = {
        aliId: sj.aliId,
      };
      this.showvideo = true;
      //  getAction("/lxBase/lxApplyResource/allList", {
      //   applyId: this.oldInfos.id,
      //   applyType: 3,
      // }).then((res) => {
      //   if (res.code === 200) {
      //     // console.log("111111");
      //     this.sjData = res.result;
      //     if (this.sjData.aliId) {
      //       this.showvideo = true;
      //     }
      //     // this.previewUrl = res.result.filePath;
      //   }
      // });
    },
    handlePreview(f) {
      if (this.isEdit) {
        // if (
        //   f.path != "" &&
        //   f.path != null) {
        //   //  this.titlename = f.name;
        //   this.showvideo = true;
        //   this.previewUrl = f.path;
        // } else {
        //   // this.$message.warning("建设总结方案暂未上传，请上传后预览");
        // }
        getAction("/lxBase/lxApplyResource/getResourceByApplyId", {
          applyId: this.oldInfos.id,
        }).then((res) => {
          if (res.code === 200) {
            // console.log("111111");
            this.sjData = res.result;
            if (
              (this.sjData.aliId || this.sjData.filePath) &&
              this.sjData.type == 0
            ) {
              this.showvideo = true;
            }
            // this.previewUrl = res.result.filePath;
          }
        });
      }
    },
    getbq() {
      console.log(this.oldInfos, "this.oldInfos");
      if (
        this.$parent.editInfo?.auditState == "2" &&
        this.$store.state.role == "school-role"
      ) {
        getAction("/lxBase/lxApplyResource/allList", {
          applyId: this.oldInfos.id,
          applyType: 3,
        }).then((res) => {
          if (res.code === 200) {
            console.log(this.oldInfos.hasResource);
            this.bqInfo = res.result;
            this.info.id = res.result.id;
            this.info.type = this.normalizeResourceType(res.result.type);
            // if (
            //   res.result &&
            //   res.result.filePath != "" &&
            //   res.result.filePath != "null" &&
            //   res.result.filePath != undefined
            // ) {
            //   this.fileList = [];
            //   let fileItem = {};
            //   fileItem.path = res.result.filePath;
            //   fileItem.name = res.result.name;
            //   fileItem.uid = -100;
            //   this.fileList.push(fileItem);
            // }
            if (
              res.result &&
              res.result.aliId != "" &&
              res.result.aliId != "null" &&
              res.result.aliId != undefined
            ) {
              this.info.aliId = res.result.aliId;
              console.log(this.info.aliId, "this.info.aliId allList");
              this.fileList = [];
              let fileItem = {};
              fileItem.path = res.result.filePath;
              fileItem.name = res.result.name;
              fileItem.uid = -100;
              this.fileList.push(fileItem);
            }
            if (res.result.type == 1) {
              this.info.name = res.result.name;
              this.info.filePath = res.result.filePath;
            }
            if (res.result && res.result.ideologicalElement) {
              let ideologicalElement = res.result.ideologicalElement;
              if (ideologicalElement.indexOf(",") != "-1") {
                this.info.ideologicalElement = ideologicalElement.split(",");
              } else {
                let arr = [];
                arr.push(ideologicalElement);
                this.info.ideologicalElement = arr;
              }
            }
          }
        });
      } else {
        getAction("/lxBase/lxApplyResource/getResourceByApplyId", {
          applyId: this.oldInfos.id,
        }).then((res) => {
          if (res.code === 200 && res.result) {
            this.info.id = res.result.id;
            this.info.type = this.normalizeResourceType(res.result.type);
            // if (
            //   res.result &&
            //   res.result.filePath != "" &&
            //   res.result.filePath != "null" &&
            //   res.result.filePath != undefined
            // ) {
            //   this.fileList = [];
            //   let fileItem = {};
            //   fileItem.path = res.result.filePath;
            //   fileItem.name = res.result.name;
            //   fileItem.uid = -100;
            //   this.fileList.push(fileItem);
            // }

            if (
              res.result &&
              res.result.aliId != "" &&
              res.result.aliId != "null" &&
              res.result.aliId != undefined
            ) {
              this.fileList = [];
              let fileItem = {
                uid: res.result.id || "-1", // 使用唯一ID
                name: res.result.name,
                status: "done", // 重要：标记为已完成
                url: res.result.filePath, // 使用url字段
                path: res.result.filePath,
                // 如果需要，可以添加阿里云ID
                aliId: res.result.aliId,
              };
              this.fileList.push(fileItem);
              console.log(this.fileList, "this.fileList");
              this.info.aliId = res.result.aliId;
            }
            if (
              !res.result.aliId &&
              res.result.filePath &&
              res.result.type == 0
            ) {
              this.fileList = [];
              let fileItem = {
                uid: res.result.id || "-2", // 使用唯一ID
                name: res.result.name,
                status: "done", // 重要：标记为已完成
                url: res.result.filePath, // 使用url字段
                path: res.result.filePath,
                // 如果需要，可以添加阿里云ID
                aliId: res.result.aliId,
              };
              this.fileList.push(fileItem);
              console.log(this.fileList, "this.fileList 本地视频");
            }
            if (res.result.type == 1) {
              this.info.name = res.result.name;
              this.info.filePath = res.result.filePath;
            }
            if (res.result && res.result.ideologicalElement) {
              let ideologicalElement = res.result.ideologicalElement;
              if (ideologicalElement.indexOf(",") != "-1") {
                this.info.ideologicalElement = ideologicalElement.split(",");
              } else {
                let arr = [];
                arr.push(ideologicalElement);
                this.info.ideologicalElement = arr;
              }
            }
          }
        });
      }
    },
    getysList() {
      getAction("/infrastructure/lxIdeologicalElement/list", {}).then((res) => {
        //			console.log(res);
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.ysList = data;
          }
        }
      });
    },
    handleRemove(file, fileList) {
      // this.fileList = this.fileList.filter((item) => {
      //   if (item.path.indexOf(file.name1) === -1) {
      //     return item;
      //   }
      // });
      // const index = this.fileList.indexOf(file);
      // const newFileList = this.fileList.slice();
      // newFileList.splice(index, 1);
      // this.fileList = newFileList;
      this.fileList = [];
      this.info.fileName = "";
      this.info.filePath = "";
    },
    beforeUpload(file, fileList) {
      console.log("file beforeUpload", file);
      console.log("fileList beforeUpload", fileList);
      this.handleUpload(file, fileList);
      return false;
    },
    uploadFiles(params) {
      // let obj = {
      //   //添加资源参数
      //   aliId: params.aliId, // 阿里云存放id
      //   // courseId: this.$store.state.courseId, //  课程id
      //   // coverImg: data.coverImgpath, //  封面图片
      //   fileType: params.fileType, // 资源源文件类型
      //   fileUrl: params.fileUrl, // 资源源文件地址
      //   // id:"",            // 主键
      //   name: params.name, // 资源名称
      //   previewUrl: params.previewUrl, // 转换后文件地址
      //   resourceDuration: params.resourceDuration, // 资源时长
      //   // sort: 0, //  排序
      //   sourceType: params.sourceType, // 来源类型
      //   // startClassId: this.$store.state.constructionId, //  开课id
      //   // teachContentId:"",   //  教学内容内容id
      //   // teachingWeek: this.params2.teachingWeek, // 教学周
      //   uid: params.uid,
      // };
      this.info.aliId = params.aliId;
      this.info.fileName = params.name;
      this.info.filePath = params.fileUrl;
      this.fileList = [];
      let fileItem = {};
      fileItem.path = params.fileUrl;
      fileItem.name = params.name;
      fileItem.uid = -100;
      this.fileList.push(fileItem);
      console.log(params);
      // if (params.aliId) {
      //   obj.format = params.format;
      // }
      // this.sourceUploadList.push(obj);
      // console.log(this.sourceUploadList)
    },
    createUploader() {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          self.loading = true;
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)

          // self.$emit("handleIsSubmt", true);
          // console.log("444444",uploadInfo);
          self.$forceUpdate();
          self.loading = true;
          if (!uploadInfo.videoId) {
            // let createUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6'
            // let createUrl='https://vod.cn-shanghai.aliyuncs.com/?Action=CreateUploadVideo' +
            //   '&FileName=' + uploadInfo.file.name+
            //   '&title=UploadTest'

            // axios.get(createUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })

            // var params = {
            //   FileName:uploadInfo.file.name,
            //   Title:uploadInfo.file.name
            // }
            const params = new FormData();
            params.append("FileName", uploadInfo.file.name);
            params.append("Title", uploadInfo.file.name.split(".")[0]);
            params.append("CateId", "11095");
            postAction("/sys/video/CreateUploadVideo", params).then((res) => {
              // console.log(res,'4444444444444444444')
              let uploadAuth = res.result.uploadAuth;
              let uploadAddress = res.result.uploadAddress;
              let videoId = res.result.videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
            self.statusText = "文件开始上传...";
          } else {
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            // axios.get(refreshUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })
            // console.log("444444",'这里');
            postAction(
              `/sys/video/refresVideoPlayAuth?videoId=${uploadInfo.videoId}`
            ).then((res) => {
              let uploadAuth = res.result.uploadAuth;
              let uploadAddress = res.result.uploadAddress;
              let videoId = res.result.videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          self.statusText = "文件上传成功!";

          const params = {
            // name: uploadInfo.file.name,
            // path: uploadInfo.object,
            // size: uploadInfo.file.size,
            // fileId: uploadInfo.videoId,
            aliId: uploadInfo.videoId,
            fileType: "VIDEO", //	资源源文件类型
            fileUrl: "", //	资源源文件地址
            name: uploadInfo.file.name, //	资源名称
            previewUrl: "", //	转换后文件地址
            resourceDuration: 0, //	资源时长
            sourceType: "alioss",
            uid: uploadInfo.file.uid,
            format: ".mp4",
          };
          console.log("sssss", params);
          self.loading = false;
          self.uploadFiles(params);
          self.info.aliId = uploadInfo.videoId;
          // self.$emit("uploadFile", params);
          self.fileList.forEach((item, index) => {
            if (item) {
              self.fileList.splice(index, 1);
            }
          });
          self.fileList.push(params);
          // self.showProgress = false;
          // self.$emit("handleIsSubmt", false);
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          let progressPercent = Math.ceil(progress * 100);
          self.authProgress = progressPercent;
          self.percent = progressPercent;
          self.statusText = "文件上传中...";
          console.log(progressPercent, "3333");
          self.loading = true;
          if (progressPercent == 100) {
          }
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
          // axios.get(refreshUrl).then(({data}) => {
          //   let uploadAuth = data.UploadAuth
          //   uploader.resumeUploadWithAuth(uploadAuth)
          // })

          postAction(
            `/sys/video/refresVideoPlayAuth?videoId=${uploadInfo.videoId}`
          ).then((res) => {
            let uploadAuth = res.result.uploadAuth;
            uploader.resumeUploadWithAuth(uploadAuth);
          });
          self.loading = false;
          self.fileList = [];
          self.statusText = "文件超时...";
        },
        onUploadFailed() {
          console.log("22222");
          self.$message.error("上传失败");
          self.fileList = [];
          self.loading = false;
        },
      });
      return uploader;
    },
    handleUpload(file, fileList) {
      console.log("file handleUpload", file);
      console.log("fileList handleUpload", fileList);
      if (this.fileList.length >= 1) {
        this.$message.error("思政微课只能上传一个文件,请移除后再上传");
        return;
      }
      if (file.type == "video/mp4") {
        console.log("此处应该使用阿里云的视频上传");
        this.file = file;
        // 简化的阿里云上传视频
        var userData = '{"Vod":{}}';
        this.uploader = this.createUploader();
        this.uploader.addFile(this.file, null, null, null, userData);
        this.uploader.startUpload();
        this.fileList = fileList;
      } else {
        this.$message.error("请上传规定格式的文件");
        return false;
      }

      // this.loading = true;
      // const formData = new FormData();
      // formData.append("file", file);
      // formData.append("biz", "linxuan");
      // fileUpdate(formData).then((res) => {
      //   if (res.code === 0) {
      //     this.$message.success(`上传成功`);
      //     let fileItem = {};
      //     fileItem.path = res.message;
      //     fileItem.name = file.name;
      //     fileItem.uid = file.uid;
      //     this.fileList.push(fileItem);
      //     this.loading = false;
      //   } else {
      //     this.$message.error("上传失败");
      //   }
      // });
    },
    upStep2() {
      this.$emit("upStep2", this.fileList, this.info);
    },

    validate() {
      if (this.loading) {
        this.$message.warning("文件正在上传，请上传成功后提交");
        return false;
      }
      if (this.info.type == 0) {
        if (!this.info.aliId && this.fileList.length == 0) {
          this.$message.info("请上传思政微课视频");
          return false;
        }
        if (this.fileList.length === 0) {
          this.$message.info("请上传思政微课视频");
          return false;
        }
      }
      if (this.info.type == 1) {
        if (!this.info.name || this.info.name.trim() === "") {
          this.$message.info("请输入超链接名称");
          return false;
        }
        if (!this.info.filePath || this.info.filePath.trim() === "") {
          this.$message.info("请输入超链接地址");
          return false;
        }
      }
      if (
        !this.info.ideologicalElement ||
        this.info.ideologicalElement.length == 0
      ) {
        this.$message.info("请添加思政元素");
        return false;
      }
      return true;
    },
    submit() {
      return this.save({ skipValidate: false, stay: false });
    },
    save(options) {
      const opts = options || {};
      const skipValidate = opts.skipValidate;
      const stay = opts.stay;
      const silent = opts.silent;
      if (this.loading) {
        this.$message.warning("文件正在上传，请上传成功后提交");
        return Promise.reject(new Error("uploading"));
      }
      if (!skipValidate && !this.validate()) {
        return Promise.reject(new Error("validate"));
      }
      const applyId =
        (this.oldInfos && this.oldInfos.id) ||
        (this.$parent.baseInfo && this.$parent.baseInfo.id);
      if (!applyId) {
        return Promise.resolve();
      }
      const elements = this.info.ideologicalElement || [];
      let params = {
        ideologicalElement: Array.isArray(elements)
          ? elements.join()
          : elements,
        applyId: applyId,
        id: this.info.id,
        type: this.info.type,
        sourceType: this.info.sourceType,
      };
      if (this.info.type == 0) {
        params.filePath = this.fileList[0]?.path || "";
        params.name = this.fileList[0]?.name || "";
        params.aliId = this.info.aliId || "";
      } else {
        params.filePath = this.info.filePath || "";
        params.name = this.info.name || "";
        params.aliId = "";
      }
      const finish = (res) => {
        if (res.code == 200 || res.code === 200) {
          if (res.result && res.result.id) {
            this.info.id = res.result.id;
          }
          if (!silent) this.$message.success("保存成功");
          if (!stay) {
            this.$router.push({ name: "szMicroClass" });
            window.sessionStorage.removeItem(
              `step${this.$store.state.user.id}`
            );
          }
          return res;
        }
        this.$message.error(res.message);
        return Promise.reject(res);
      };
      if (
        this.bqInfo?.status == "1" ||
        this.bqInfo?.status == "0" ||
        this.bqInfo?.status == "4" ||
        this.bqInfo?.status == "3"
      ) {
        let params1 = {
          id: this.bqInfo?.taskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        };
        return putAction("/audit/lxAuditTask/editTaskAndDetail", params1).then(
          finish
        );
      }
      return postAction("/lxBase/lxApplyResource/saveOrUpdate", params).then(
        finish
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/components/projectShell/updatePage.scss";
.card-item{
  padding:0px!important;
  box-shadow: none!important;
}
.ps-supply-form {
  margin-bottom: 0;
}
.ps-compare-link {
  margin-left: 10px;
  display: inline-block;
  color: #2155b5;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
}
</style>
